import { organizations } from '../../../services/api.admin';
import { fetchTableData, deleteTableData } from '../tables';
import { ADMIN_CONTEXT } from '../../../constants/actions';
import { push } from 'react-router-redux';
import { ADMIN_ORG_DETAILS_PATH, ADMIN_ORG_NEW_PATH } from '../../../constants/routes';
import { MODELS, ADDRESS_FIELDS } from '../../../constants/admin/settings';
import { fetchModel, submit } from '../forms';
import { pick } from 'lodash';

export function fetchList(_, pagination) {
    return fetchTableData(() => organizations.get(pagination), 'organizations', { pagination });
}

export function openOrganization(item) {
    return push(ADMIN_ORG_DETAILS_PATH.replace(':context', item.id));
}

export function toNew() {
    return push(ADMIN_ORG_NEW_PATH);
}

export function create(data) {
    return submit(() => organizations.create(_permitBody(data)), 'Organization successfully created.', {
        beforeDone: (response, dispatch, _getState, doneFunction) => {
            dispatch({
                type: ADMIN_CONTEXT.ADD,
                newItem: { name: data.name, id: response.id }
            });
            doneFunction();
        }
    });
}

export function update(data, id, _, onSuccess) {
    return submit(() => organizations.update(id, _permitBody(data)), 'Organization successfully updated.', {
        beforeDone: (_response, dispatch, _getState, doneFunction) => {
            dispatch({ type: ADMIN_CONTEXT.UPDATE, id: id, name: data.name });
            onSuccess && onSuccess();
            doneFunction();
        }
    });
}

export function deleteOrganizations() {
    return deleteTableData(organizations.delete, MODELS.ORGANIZATION);
}

export function fetchMember(id) {
    return fetchModel(() => organizations.getMember(id), MODELS.ORGANIZATION);
}

const _permitBody = data => pick(data, ['name', 'timeZone'].concat(Object.keys(ADDRESS_FIELDS)));



// WEBPACK FOOTER //
// ./src/actions/admin/models/organizations.js